
import useCoordinatingGroups from "@/hooks/data/useCoordinatingGroups";
import { createContext } from "react"

export interface ICoordinatingGroupsContext extends ReturnType<typeof useCoordinatingGroups> {
}

export const CoordinatingGroupsContext = createContext<ICoordinatingGroupsContext>({
    data: undefined,
    idMap: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default CoordinatingGroupsContext;